export const isNumber = (value: any): value is number => {
    return typeof value === 'number' && value === value
}
